export default __webpack_public_path__ + "static/MNSMBLUEFLAMESATINJACKET_600x600-061e16a3eadcbf5f7447ba4c098de901.png";